import Cookies from 'js-cookie'

const feature = {
  state: {
    dateType: Cookies.get('taskmaster_dateType') ? Cookies.get('taskmaster_dateType') : 'year',
    readTitle: Cookies.get('taskmaster_readTitle') ? Cookies.get('taskmaster_readTitle') : '',
    dates: Cookies.get('taskmaster_dates') ? Cookies.get('taskmaster_dates') : '',
    search: Cookies.get('taskmaster_search') ? Cookies.get('taskmaster_search') : '',
  },
  getters: {
    dateType: state => state.dateType,
    readTitle: state => state.readTitle,
    dates: state => state.dates,
    search: state => state.search
  },
  mutations: {
    SET_TASKMASTER_DATE_TYPE: (state, dateType) => {
      state.dateType = dateType
    },
    SET_READ_TITLE: (state, readTitle) => {
      state.readTitle = readTitle
    },
    SET_TASKMASTER_DATES: (state, dates) => {
      state.dates = dates
    },
    SET_TASKMASTER_SEARCH: (state, search) => {
      state.search = search
    }
  },
  actions: {
    SetTaskmasterDateType({ commit }, dateType) {
      Cookies.set('taskmaster_dateType', dateType)
      // console.log("dateType", dateType)
      commit('SET_TASKMASTER_DATE_TYPE', dateType)
    },
    SetTaskmasterReadTitle({ commit }, readTitle) {
      Cookies.set('taskmaster_readTitle', readTitle)
      commit('SET_READ_TITLE', readTitle)
    },
    SetTaskmasterDates({ commit }, dates) {
      Cookies.set('taskmaster_dates', dates)
      // console.log("taskmaster_dates", dates)
      commit('SET_TASKMASTER_DATES', dates)
    },
    SetTaskmasterSearch({ commit }, search) {
      Cookies.set('taskmaster_search', search)
      commit('SET_TASKMASTER_SEARCH', search)
    }
  }
}

export default feature



// WEBPACK FOOTER //
// ./src/store/modules/taskmaster.js